import { readEnvVariable } from '../helpers';

// Two Zernio accounts: the original (`default`, Instagram + TikTok) and the
// second brand (`brand2`, YouTube + X), each with its OWN API key + webhook
// secret. The `*_2` vars are optional: `readEnvVariable` returns '' when unset,
// so the code deploys before the second account's secrets exist and `brand2`
// simply stays dormant (no brand2 channels are synced until the key is set).
// The account-key -> field mapping lives in the API's `social-shared` resolver.
export interface ISocialEnv {
  zernioApiKey: string;
  zernioWebhookSecret: string;
  zernioApiKey2: string;
  zernioWebhookSecret2: string;
  bufferApiKey: string;
}

export function getSocialEnv(): ISocialEnv {
  return {
    zernioApiKey: readEnvVariable('SOCIAL_ZERNIO_API_KEY'),
    zernioWebhookSecret: readEnvVariable('SOCIAL_ZERNIO_WEBHOOK_SECRET'),
    zernioApiKey2: readEnvVariable('SOCIAL_ZERNIO_API_KEY_2'),
    zernioWebhookSecret2: readEnvVariable('SOCIAL_ZERNIO_WEBHOOK_SECRET_2'),
    bufferApiKey: readEnvVariable('SOCIAL_BUFFER_API_KEY'),
  };
}
